import moment from 'moment-timezone';
import { isCountryVietnam } from '../constants/countries';

/**
 * Every display in the app runs in the zone baked into the build —
 * `moment.tz.setDefault(config.get('tzName'))` in `containers/Root.jsx`. CPI-1109 established that
 * Vietnam companies must instead read timestamps in the viewer's own browser zone, so one instant
 * shows 11:03 in Ho Chi Minh, 12:03 in Kuala Lumpur and 04:03 in UTC.
 *
 * That rule used to live inside the connected `components/Timestamp`, which left every caller that
 * formats a Moment directly — tooltips, `title` attributes, activity before/after values, grouping
 * keys — rendering in the build zone. These two helpers are the single source of truth for the
 * rule so those callers stop re-implementing it.
 *
 * Scope is display only. Date-only calendar fields, picker inputs, query ranges, operational
 * schedules, countdown maths and API serialization keep the configured zone and must not use this.
 */

/**
 * A fresh Moment for display: browser-local for Vietnam companies, configured zone otherwise.
 * `value` is anything Moment accepts, and `undefined` means now exactly as it does in Moment. The
 * argument is never mutated — `moment(value)` clones a Moment input — and neither is the global
 * default, the locale or any store state.
 */
export function displayMoment(value, countryCode) {
  const m = moment(value);
  return isCountryVietnam(countryCode) ? m.local() : m;
}

/**
 * The matching reference clock. Calendar-relative formats (Today/Yesterday, "still this year")
 * compare the value against now, so both sides have to be read in the same zone or the chosen
 * branch is itself wrong near midnight and at the year boundary.
 */
export function displayNow(countryCode) {
  return displayMoment(undefined, countryCode);
}



// WEBPACK FOOTER //
// ./src/utils/displayTime.js